import React from 'react';
import PropTypes from 'prop-types';

import { GroupLabel, InputLabel, InputRadio, InputWrapper, OptionsWrapper, } from './textRadioComponentStyles';

const Option = ({
	name, idx, onChange,
	value, tight, option,
}) => (
	<InputWrapper key={`text-radio-${name}-${idx}`} tight={tight}>
		<InputRadio id={`text-radio-${name}-${idx}`} onChange={onChange} name={name} value={option.value} checked={value == option.value} />
		<InputLabel htmlFor={`text-radio-${name}-${idx}`} checked={value == option.value} data-display={option.display}>{option.display}</InputLabel>
	</InputWrapper>
);

const TextRadioComponent = ({
	className, label, value, options,
	onChange, name, required, tight,
}) => (
	<div className={className}>
		{label && <GroupLabel>{label}{required && ' *'}</GroupLabel>}
		<OptionsWrapper>
			{options && options.map((option, idx) => (
				<Option key={`text-radio-${name}-${idx}`} name={name} idx={idx} onChange={onChange} value={value} tight={tight} option={option} />
			))}
		</OptionsWrapper>
	</div>
);

TextRadioComponent.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			display: PropTypes.string,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			enabled: PropTypes.bool,
		})
	),
	onChange: PropTypes.func,
	name: PropTypes.string,
	required: PropTypes.bool,
	tight: PropTypes.bool,
};

TextRadioComponent.defaultProps = {
	tight: false,
};

export { TextRadioComponent };
